jQuery(document).ready(function () {
    'use strict';

    $(document).on('click', '.listaction-root div.listaction-element .confirm-before', showConfirmBox);

    function showConfirmBox() {
        var $actionLink = jQuery(this);
        var $listElement = jQuery($actionLink.closest('div.listaction-element'));
        var $rootContainer = jQuery($listElement.closest('div.listaction-root'));
        var $confirmTargetButton = $actionLink.data('remodal-target');
        var $remodalContainer = jQuery('div[data-remodal-id=' + $confirmTargetButton + ']');
        var $confirmButton = $remodalContainer.find('#confirm-delete');
        var elementType = $actionLink.data('elm-type');

        $confirmButton.off('click').click(function () {
            let $this = $(this);
            $this.prop('disabled', true);
            performDelete($rootContainer, $listElement, $actionLink.attr('data-href'), $confirmButton.attr("data-error-msg"), $remodalContainer, $this, elementType);
        });
    }

    function performDelete($rootContainer, $blockContainer, deleteUrl, errorMsg, modal, $trigger_current, elementType) {
        let $preferencePageContainer = $('.section__modify');
        $blockContainer.addClass('in-progress');
        $rootContainer.find('div.listaction-element').removeClass('in-error');
        $rootContainer.find('#alert').addClass('hide');

        TINK.sessionAjax({
            url: deleteUrl,
            type: 'post',
            success: function (data, textStatus, jqXHR) {
                if ($blockContainer.siblings().length === 1) {
                    jQuery(".list-empty-label").removeClass('hide');
                    var buttonSelectorToDisable = $rootContainer.data("disable-button-selector");
                    if (buttonSelectorToDisable) {
                        jQuery(buttonSelectorToDisable).prop('disabled', true);
                    }
                }
                $blockContainer.remove();
                if ($trigger_current.attr('data-delete-payment') !== undefined) {
                    try {
                        eval($trigger_current.attr('data-delete-payment'));
                    } catch (error) {
                        console.warn('Show payment block verify', error);
                    }
                }

                if ($preferencePageContainer.length) {
                    $preferencePageContainer.hide();
                }

                if (typeof inBuyerPreferences !== "undefined") {
                    refreshAddresses();
                }

            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    $blockContainer.addClass('in-error');
                    $rootContainer.find('#alert')
                        .removeClass('hide')
                        .find('a.focusOnMyAnchor')
                        .attr('href', '#' + $blockContainer.attr('id'))
                        .text(errorMsg)
                        .focus();
                }
            },
            complete: function (jqXHR, textStatus) {
                $blockContainer.removeClass('in-progress');
                modal.remodal().close();
                modal.on('closed', function() {
                    $trigger_current.prop('disabled', false);
                });
                if (elementType == 'paymentMethod') {
                    location.reload();
                }
            }
        });

        function refreshAddresses() {
            TINK.sessionAjax({
                url: buyerPreferencesUrl + '/addressList',
                success: function (data) {
                    $('#addressListContainer').html(data);
                    $('#cancelAddressChange').click();
                },
                error: function (jqXHR) {
                    TINK.redirectIfConflict(jqXHR);
                }
            });
        }
    }
});
